import React from "react";
/**
 * Description Component
 * 
 * Renders text content with consistent styling in a card format.
 * 
 * @param {string|string[]} text - Content to display
 *   - String: renders as a single paragraph
 *   - Array: renders each element as a separate paragraph
 * 
 * @example
 * // Single line
 * <Description text="This is a single paragraph" />
 * 
 * @example
 * // Multiple paragraphs
 * <Description text={[
 *   "First paragraph with its own content",
 *   "Second paragraph here",
 *   "Third paragraph"
 * ]} />
 */
export default function Description({ text }) {
    const renderText = () => {
        if (Array.isArray(text)) {
            return text.map((line, index) => (
                <p key={index} className="desc-text text-gray mb-0">
                    {line}
                </p>
            ));
        }
        return <p className="desc-text text-gray mb-0">{text}</p>;
    };

    return (
        <div className="decs-card py-4">
            <div style={{ padding: '2rem 4rem' }}>
                {renderText()}
            </div>
        </div>
    )
}